import { useQuery } from '@tanstack/react-query';
import { leaderboardApi } from '../lib/api';

export function useLeaderboard(params?: { period?: string; limit?: number }) {
  return useQuery({
    queryKey: ['leaderboard', params],
    queryFn: async () => {
      const res = await leaderboardApi.getLeaderboard(params);
      return res.data;
    },
  });
}
